import { Phone } from '@app/entities/interfaces/ptrab/shared/phone.interface';

export class Phones {
  phones!: Phone[];
  message!: string;
}
